module.exports = __webpack_public_path__ + "img/ic_super_feedback.8eaa1619.png";